import {
	AfterViewInit,
	Component,
	ElementRef,
	NgZone,
	OnChanges,
	OnDestroy,
	SimpleChanges,
	ViewChild,
	ViewEncapsulation,
} from '@angular/core';
import { AttentionCard } from '@components/attention_card/mod';
import { createRoot, Root } from 'react-dom/client';
import { CellulaProviderWrapper } from './cellula_provider_wrapper.component';

const containerElementName = 'reactHeaderComponent';

@Component({
	standalone: false,
	selector: 'attention-card-component',
	template: `<div class="wrapper-container" #${containerElementName}></div>`,
	encapsulation: ViewEncapsulation.None,
})
export class AttentionCardWrapper implements OnChanges, OnDestroy, AfterViewInit {
	@ViewChild(containerElementName, { static: false }) public containerRef: ElementRef;

	private root: Root;

	constructor(private readonly ngZone: NgZone) {
		// Empty
	}

	ngOnChanges(_: SimpleChanges): void {
		this.render();
	}

	ngAfterViewInit() {
		this.render();
	}

	ngOnDestroy() {
		this.root?.unmount();
	}

	private render() {
		const root = createRoot(this.containerRef.nativeElement);
		this.root = root;

		this.ngZone.runOutsideAngular(() => {
			root.render(
				<CellulaProviderWrapper>
					<AttentionCard />
				</CellulaProviderWrapper>,
			);
		});
	}
}
